import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
/** @jsx jsx */

import { useEffect } from 'react';
import { jsx } from '@emotion/core';
import { DEFAULT_TOP_NAVIGATION_HEIGHT, VAR_TOP_NAVIGATION_HEIGHT } from '../../common/constants';
import { getPageLayoutSlotSelector, resolveDimension } from '../../common/utils';
import { publishGridState, useSkipLink } from '../../controllers';
import SlotDimensions from './slot-dimensions';
import { topNavigationStyles } from './styles';

var TopNavigation = function TopNavigation(props) {
  var children = props.children,
      _props$height = props.height,
      height = _props$height === void 0 ? DEFAULT_TOP_NAVIGATION_HEIGHT : _props$height,
      _props$isFixed = props.isFixed,
      isFixed = _props$isFixed === void 0 ? true : _props$isFixed,
      shouldPersistHeight = props.shouldPersistHeight,
      testId = props.testId,
      id = props.id,
      skipLinkTitle = props.skipLinkTitle;
  var topNavigationHeight = resolveDimension(VAR_TOP_NAVIGATION_HEIGHT, height, shouldPersistHeight);
  useEffect(function () {
    publishGridState(_defineProperty({}, VAR_TOP_NAVIGATION_HEIGHT, topNavigationHeight));
    return function () {
      publishGridState(_defineProperty({}, VAR_TOP_NAVIGATION_HEIGHT, 0));
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [topNavigationHeight]);
  useSkipLink(id, skipLinkTitle);
  return jsx("div", _extends({
    css: topNavigationStyles(isFixed),
    "data-testid": testId,
    id: id
  }, getPageLayoutSlotSelector('top-navigation')), jsx(SlotDimensions, {
    variableName: VAR_TOP_NAVIGATION_HEIGHT,
    value: topNavigationHeight
  }), children);
};

export default TopNavigation;